import { CLOVER_RECEIPTS } from '../actionTypes';

const initialState = {
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CLOVER_RECEIPTS.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
